if(!customElements.get("scroll-to")){class a extends HTMLElement{constructor(){super(),this.addEventListener("click",()=>this.onClick())}onClick(){document.querySelector(this.getAttribute("href")).scrollIntoView({behavior:"smooth"})}}customElements.define("scroll-to",a)}

/* Plynne przewijanie dla ZWYKLYCH odnosnikow kotwicowych oznaczonych
   atrybutem data-scroll-smooth (np. "Zobacz wszystkie opinie" na karcie
   produktu). Element <scroll-to> wyzej nie jest odnosnikiem - nie ma
   semantyki linku ani obslugi klawiatury - a tutaj chcemy zachowac <a>
   z prawdziwym adresem, zeby dzialalo takze bez JavaScriptu i dalo sie
   otworzyc z klawiatury.

   Swiadomie NIE ustawiamy "scroll-behavior: smooth" na elemencie glownym:
   ta wlasciwosc dziala na CALY dokument, a motyw przywraca pozycje strony
   po zamknieciu szuflady zwyklym przewinieciem - przy plynnym przewijaniu
   ten powrot zaczalby sie animowac.

   PULAPKA - cel UCIEKA w trakcie animacji. Przewijanie jest liczone do
   pozycji z chwili klikniecia, a po drodze doczytuja sie zdjecia (leniwe
   ladowanie) i dokument rosnie. Na karcie produktu sekcja opinii lezy
   okolo 5000 px nizej, wiec animacja konczyla sie prawie 300 px nad nia.
   Dlatego po zakonczeniu przewijania pozycja jest sprawdzana i dociagana,
   maksymalnie trzy razy - licznik chroni przed petla, gdy strona rosnie
   caly czas.

   Odstep od gory bierzemy z wlasciwosci scroll-margin-top celu, czyli tej
   samej, ktorej uzywa zwykly przeskok kotwicy - nie ma drugiego zrodla. */
(() => {
    const MAX_DOCIAGNIEC = 3;
    const TOLERANCJA = 8;

    const odstepCelu = (cel) => parseFloat(getComputedStyle(cel).scrollMarginTop) || 0;

    const przewin = (cel, plynnie) => {
        cel.scrollIntoView({ behavior: plynnie ? "smooth" : "auto", block: "start" });
    };

    const dociagnij = (cel, plynnie, proba) => {
        if (proba > MAX_DOCIAGNIEC) return;

        const czekaj = (dalej) => {
            let zrobione = false;
            const raz = () => {
                if (zrobione) return;
                zrobione = true;
                window.removeEventListener("scrollend", raz);
                dalej();
            };
            window.addEventListener("scrollend", raz, { once: true });
            setTimeout(raz, plynnie ? 1200 : 120);
        };

        czekaj(() => {
            if (Math.abs(cel.getBoundingClientRect().top - odstepCelu(cel)) <= TOLERANCJA) return;
            przewin(cel, plynnie);
            dociagnij(cel, plynnie, proba + 1);
        });
    };

    document.addEventListener("click", (e) => {
        const link = e.target.closest("a[data-scroll-smooth]");
        if (!link) return;

        const href = link.getAttribute("href") || "";
        if (!href.startsWith("#") || href === "#") return;

        const cel = document.getElementById(href.slice(1));
        if (!cel) return;

        e.preventDefault();
        const plynnie = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        przewin(cel, plynnie);
        dociagnij(cel, plynnie, 1);

        /* adres w pasku ma sie zmienic tak samo jak przy zwyklym odnosniku,
           ale bez dodawania wpisu do historii przegladarki */
        if (history.replaceState) history.replaceState(null, "", href);
    });
})();
